const defaultState = {
  isProcessingBuyOLP: false,
  isLoadingPrivateOffer: false,
  isUpdateingPrivateOffer: false,
  isUpdateingSaleTransaction: false,
  usdPrice: 0,
  usdtToUsdPrice: 0,
  listTabContents: [],
};

export const TYPES = {
  SUBMIT_BUY_OLP: 'SUBMIT_BUY_OLP',
  SUBMIT_BUY_OLP_SUCCESS: 'SUBMIT_BUY_OLP_SUCCESS',
  SUBMIT_BUY_OLP_FAILED: 'SUBMIT_BUY_OLP_FAILED',
  FETCH_QUOTES: 'FETCH_QUOTES',
  FETCH_QUOTES_SUCCESS: 'FETCH_QUOTES_SUCCESS',
  FETCH_QUOTES_FAILED: 'FETCH_QUOTES_FAILED',
  FETCH_PRIVATE_OFFERS: 'FETCH_PRIVATE_OFFERS',
  FETCH_PRIVATE_OFFERS_SUCCESS: 'FETCH_PRIVATE_OFFERS_SUCCESS',
  FETCH_PRIVATE_OFFERS_FAILED: 'FETCH_PRIVATE_OFFERS_FAILED',

  UPDATE_PRIVATE_OFFER: 'UPDATE_PRIVATE_OFFER',
  UPDATE_PRIVATE_OFFER_SUCCESS: 'UPDATE_PRIVATE_OFFER_SUCCESS',
  UPDATE_PRIVATE_OFFER_FAILED: 'UPDATE_PRIVATE_OFFER_FAILED',

  UPDATE_SALE_TRANSACTION: 'UPDATE_SALE_TRANSACTION',
  UPDATE_SALE_TRANSACTION_SUCCESS: 'UPDATE_SALE_TRANSACTION_SUCCESS',
  UPDATE_SALE_TRANSACTION_FAILED: 'UPDATE_SALE_TRANSACTION_FAILED',

  FETCH_TAB_CONTENTS: 'FETCH_TAB_CONTENTS',
  FETCH_TAB_CONTENTS_SUCCESS: 'FETCH_TAB_CONTENTS_SUCCESS',
  FETCH_TAB_CONTENTS_FAILED: 'FETCH_TAB_CONTENTS_FAILED',

  SUBMIT_VESTING_RELEASE_TRANSACTION: 'SUBMIT_VESTING_RELEASE_TRANSACTION',
  SUBMIT_VESTING_RELEASE_TRANSACTION_SUCCESS: 'SUBMIT_VESTING_RELEASE_TRANSACTION_SUCCESS',
  SUBMIT_VESTING_RELEASE_TRANSACTION_FAILED: 'SUBMIT_VESTING_RELEASE_TRANSACTION_FAILED',

  UPDATE_VESTING_RELEASE_TRANSACTION: 'UPDATE_VESTING_RELEASE_TRANSACTION',
  UPDATE_VESTING_RELEASE_TRANSACTION_SUCCESS: 'UPDATE_VESTING_RELEASE_TRANSACTION_SUCCESS',
  UPDATE_VESTING_RELEASE_TRANSACTION_FAILED: 'UPDATE_VESTING_RELEASE_TRANSACTION_FAILED',

  FETCH_BUYLP_PERCENTAGE: 'FETCH_BUYLP_PERCENTAGE',
  FETCH_BUYLP_PERCENTAGE_SUCCESS: 'FETCH_BUYLP_PERCENTAGE_SUCCESS',
  FETCH_BUYLP_PERCENTAGE_FAILED: 'FETCH_BUYLP_PERCENTAGE_FAILED',
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case TYPES.SUBMIT_BUY_OLP:
      return { ...state, isProcessingBuyOLP: true };
    case TYPES.SUBMIT_BUY_OLP_FAILED:
      return { ...state, isProcessingBuyOLP: false };
    case TYPES.SUBMIT_BUY_OLP_SUCCESS:
      return { ...state, isProcessingBuyOLP: false };
    case TYPES.FETCH_QUOTES:
      return { ...state, isProcessingBuyOLP: true };
    case TYPES.FETCH_QUOTES_SUCCESS:
      return { ...state, usdPrice: action.data.katToUSD, usdtToUsdPrice: action.data.usdtToUSD, isProcessingBuyOLP: false };
    case TYPES.FETCH_QUOTES_FAILED:
      return { ...state, isProcessingBuyOLP: false };
    case TYPES.FETCH_PRIVATE_OFFERS:
      return { ...state, isLoadingPrivateOffer: true };
    case TYPES.FETCH_PRIVATE_OFFERS_FAILED:
      return { ...state, isLoadingPrivateOffer: false };
    case TYPES.FETCH_PRIVATE_OFFERS_SUCCESS:
      return { ...state, isLoadingPrivateOffer: false, product: action.data };

    case TYPES.UPDATE_PRIVATE_OFFER:
      return { ...state, isUpdateingPrivateOffer: true };
    case TYPES.UPDATE_PRIVATE_OFFER_FAILED:
      return { ...state, isUpdateingPrivateOffer: false };
    case TYPES.UPDATE_PRIVATE_OFFER_SUCCESS:
      return { ...state, isUpdateingPrivateOffer: false, product: action.data };

    case TYPES.UPDATE_SALE_TRANSACTION:
      return { ...state, isUpdateingSaleTransaction: true };
    case TYPES.UPDATE_SALE_TRANSACTION_FAILED:
      return { ...state, isUpdateingSaleTransaction: false };
    case TYPES.UPDATE_SALE_TRANSACTION_SUCCESS:
      return { ...state, isUpdateingSaleTransaction: false, product: action.data };

    case TYPES.SUBMIT_VESTING_RELEASE_TRANSACTION:
      return { ...state, isSubmitingVestingReleaseTransaction: true };
    case TYPES.SUBMIT_VESTING_RELEASE_TRANSACTION_FAILED:
      return { ...state, isSubmitingVestingReleaseTransaction: false };
    case TYPES.SUBMIT_VESTING_RELEASE_TRANSACTION_SUCCESS:
      return { ...state, isSubmitingVestingReleaseTransaction: false };

    case TYPES.UPDATE_VESTING_RELEASE_TRANSACTION:
      return { ...state, isUpdateingVestingReleaseTransaction: true };
    case TYPES.UPDATE_VESTING_RELEASE_TRANSACTION_FAILED:
      return { ...state, isUpdateingVestingReleaseTransaction: false };
    case TYPES.UPDATE_VESTING_RELEASE_TRANSACTION_SUCCESS:
      return { ...state, isUpdateingVestingReleaseTransaction: false, product: action.data };

    case TYPES.FETCH_TAB_CONTENTS:
    case TYPES.FETCH_TAB_CONTENTS_SUCCESS:
      return { ...state, listTabContents: action.data };
    case TYPES.FETCH_TAB_CONTENTS_FAILED:
    default:
      return state;
  }
};
